import { forEachBlock } from "../domain/document-blocks";
import {
  isFacilityLogoMediaRef,
  resolveEmailBuilderLibraryMediaSource,
} from "../domain/media";
import type { EmailDocument, ImageBlock } from "../domain/types";

function isImageBlock(block: { type: string }): block is ImageBlock {
  return block.type === "image";
}

export function emailDocumentUsesFacilityLogo(document: EmailDocument): boolean {
  let usesFacilityLogo = false;

  forEachBlock(document, ({ block }) => {
    if (!isImageBlock(block)) {
      return;
    }
    if (isFacilityLogoMediaRef(block.media)) {
      usesFacilityLogo = true;
    }
  });

  return usesFacilityLogo;
}

export function emailDocumentLibraryMediaSourcesReady(
  document: EmailDocument,
): boolean {
  let ready = true;

  forEachBlock(document, ({ block }) => {
    if (!isImageBlock(block)) {
      return;
    }

    const media = block.media;
    if (media?.kind !== "library") {
      return;
    }

    const mediaId = media.mediaId.trim();
    if (mediaId.length === 0) {
      return;
    }

    if (resolveEmailBuilderLibraryMediaSource(mediaId).length === 0) {
      ready = false;
    }
  });

  return ready;
}

export function isEmailBuilderEditorLoadGateReady(
  document: EmailDocument,
  options: {
    facilityIsLoaded: boolean;
  },
): boolean {
  if (
    emailDocumentUsesFacilityLogo(document) &&
    !options.facilityIsLoaded
  ) {
    return false;
  }

  return emailDocumentLibraryMediaSourcesReady(document);
}
